// Presentational reveal wrapper. Applies a self-contained CSS entrance
// animation (see .reveal / .art-frame in App.css) with an optional delay.
// No JS/IntersectionObserver gating, so content always settles visible.
export default function Reveal({
  as: Tag = "div",
  baseClass = "reveal",
  delay = 0,
  className = "",
  children,
  ...rest
}) {
  return (
    <Tag
      className={`${baseClass} ${className}`.trim()}
      style={{ "--reveal-delay": `${delay}s` }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
